// extracted by mini-css-extract-plugin
module.exports = {"Card":"PersonalityCard_Card__243Ej","TestName":"PersonalityCard_TestName__1Me3e","Icon":"PersonalityCard_Icon__1HlHx"};